/* eslint-disable import/prefer-default-export */
import icon from '../assets/yamato-favicon.ico';

export const yamatoConfig = {
  title: 'Yamato Scientific America',
  catalog: 'partner',
  partner: 'yamato',
  origin: 'https://www.yamato-usa.com/',
  host: 'seating.yamato-usa.com',
  logo: 'https://ecomseating.s3.us-east-1.amazonaws.com/images/other/yamato-logo.png',
  logoURL: 'https://ecomseating.s3.us-east-1.amazonaws.com/images/other/yamato-logo.png',
  buildAChair: 'Yamato Scientific America',
  businessInfo: 'Yamato Scientific America Inc. 925 Walsh Avenue, Santa Clara, CA 95050',
  headerTheme: '#FFFFFF',
  secondaryTheme: '#CA121B',
  footerTheme: '#FFFFFF',
  headerTextColor: '#0000008C',
  footerTextColor: '#0000008C',
  buttonTextColor: '#FFFFFF',
  bannerColor: '#343A40',
  extraAttributes: {
    trackId: 'G-RCRBL6EC06',
    popup: true,
    icon,
    colorOverride: {
      buttonColor: '#CA121B',
      buttonTextColor: '#FFF',
      buttonColorDark: '#CA121B',
      buttonText: '#FFFFFF',
    },
  },
};
